/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calculation': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M7 0H2a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V2a2 2 0 00-2-2zm0 5H2V4h5v1zm11 6h-5a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2v-5a2 2 0 00-2-2zm0 6h-5v-1h5v1zm0-2h-5v-1h5v1zm0-15h-5a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V2a2 2 0 00-2-2zm0 5h-2v2h-1V5h-2V4h2V2h1v2h2v1zM7 11H2a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2v-5a2 2 0 00-2-2zm-.38 5.91l-.71.71-1.41-1.41-1.41 1.41-.71-.71 1.41-1.41-1.41-1.41.71-.71 1.41 1.41 1.41-1.41.71.71-1.41 1.41 1.41 1.41z" _fill="#2CB6F8" fill-rule="evenodd"/>'
  }
})
